import _ from 'lodash';

import { h, render } from 'preact';
import FindYourDistricts from '../components/FindYourDistricts';
import Ballotdata from '../../../data/data.json';
import Contextdata from '../../../data/text.json';

// main code for feature graphics

function onSelect(data) {}

render(
  <FindYourDistricts
    onSelect={onSelect}
    contests={Ballotdata}
    flags={Contextdata.flag}
    notes={Contextdata.notes}
  />,
  document.getElementById('lookup-select')
);

let input = document.querySelector('#select-office');

let MOBILE_THRESHOLD = 544;

let containerWidth = document.getElementsByClassName('results-container')
  .offsetWidth;

let isMobile = containerWidth <= MOBILE_THRESHOLD ? true : false;

var selectedItem = sessionStorage.getItem('SelectedItem');
if (selectedItem) {
  document.getElementById('select-office').value = selectedItem;
}

input.addEventListener('change', function() {
  const elem = document.getElementById(this.value);
  sessionStorage.setItem('SelectedItem', this.value);

  scrollIt(elem);
});

function scrollIt(element) {
  const y =
    element.getBoundingClientRect().top +
    window.pageYOffset -
    (isMobile ? 115 : 75);

  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: y,
  });
}

function resize() {
  // code executed on window resize
}

// call resize on load
resize();
window.addEventListener('resize', _.debounce(resize, 200));

filterSelection('all');
function filterSelection(c, id) {
  var x, i;
  x = document.querySelectorAll('#' + String(id) + ' > .seat');

  // Add the "show" class (display:block) to the filtered elements, and remove the "show" class from the elements that are not selected
  for (i = 0; i < x.length; i++) {
    if (c == 'all') {
      w3RemoveClass(x[i], 'remove');
    } else {
      w3RemoveClass(x[i], 'remove');
      if (x[i].getElementsByClassName('office__flag').length == 0)
        w3AddClass(x[i], 'remove');
    }
  }
}

// Show filtered elements
function w3AddClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(' ');
  arr2 = name.split(' ');
  for (i = 0; i < arr2.length; i++) {
    if (arr1.indexOf(arr2[i]) == -1) {
      element.className += ' ' + arr2[i];
    }
  }
}

// Hide elements that are not selected
function w3RemoveClass(element, name) {
  var i, arr1, arr2;
  arr1 = element.className.split(' ');
  arr2 = name.split(' ');
  for (i = 0; i < arr2.length; i++) {
    while (arr1.indexOf(arr2[i]) > -1) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);
    }
  }
  element.className = arr1.join(' ');
}

// Add active class to the current control button (highlight it)
var btnContainer = document.querySelectorAll('#btnGroup');

for (var i = 0; i < btnContainer.length; i++) {
  var btns = btnContainer[i].getElementsByClassName('button');

  for (var t = 0; t < btns.length; t++) {
    btns[t].addEventListener('click', function(event) {
      var path =
        event.path ||
        (event.composedPath && event.composedPath()) ||
        composedPath(event.target);
      var currentParent = document.querySelector(
        '#btnGroup.' + path[1].className
      );
      var current = currentParent.getElementsByClassName('active');
      current[0].className = current[0].className.replace(' active', '');
      this.className += ' active';
      filterSelection(this.value, path[2].id);
    });
  }
}

// Added a function to tell when the sticky bar is stuck so that we can hide the "See who's running for:" for mobile.

const observer = new IntersectionObserver(
  ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
  { threshold: [1] }
);

observer.observe(document.querySelector('#sticky-bar'));
